import { createFileRoute, redirect } from '@tanstack/react-router'

// Entering a project lands on its first tab — Panel, the work-status reports feed.
export const Route = createFileRoute('/_authenticated/projects/$projectId/')({
	beforeLoad: ({ params }) => {
		throw redirect({
			to: '/projects/$projectId/reports',
			params: { projectId: params.projectId },
		})
	},
})
